export class Partner {
  constructor(
    public title = '',
    public logoUrl = '',
    public desc = '',
    public quote = '',
    public site = '',
  ) { }
}
